import { CUIFlex, CUISpacer } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CheckUsernameAvailable from './ClaimUsername/CheckUsernameAvailable';
import { CUIHStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import CUIImage from 'connect-dot-com-ui-components/Components/CUIImage/CUIImage';

// @ts-expect-error images have no types
import hubspotLogo from 'bender-url!../../images/hubspot-logo.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubSpotLinkedLogo = () => {
  return /*#__PURE__*/_jsx(CUILink, {
    href: "https://www.hubspot.com/",
    children: /*#__PURE__*/_jsx(CUIImage, {
      src: hubspotLogo,
      alt: "HubSpot",
      w: "108px"
    })
  });
};
const EmphasisText = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CUIText, {
    as: "span",
    bgGradient: "var(--chakra-gradients-magenta-orange)",
    bgClip: "text",
    children: children
  });
};
const HomepageHeaderContent = () => {
  return /*#__PURE__*/_jsxs(CUIFlex, {
    direction: "column",
    height: "100%",
    width: "100%",
    align: "center",
    textAlign: "center",
    gap: 6,
    children: [/*#__PURE__*/_jsxs(CUIBox, {
      maxWidth: "1000px",
      children: [/*#__PURE__*/_jsx(CUIHeading, {
        as: "h1",
        variant: "taglineHeading",
        lineHeight: "1.2 !important",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "app.homepage.header.heading_jsx",
          elements: {
            Highlight: EmphasisText
          }
        })
      }), /*#__PURE__*/_jsx(CUISpacer, {})]
    }), /*#__PURE__*/_jsxs(CUIBox, {
      children: [/*#__PURE__*/_jsx(CUIText, {
        fontSize: "lg",
        maxWidth: "700px",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.header.bodyText"
        })
      }), /*#__PURE__*/_jsx(CUIHStack, {
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(CUIText, {
          fontSize: "lg",
          maxWidth: "700px",
          my: 3,
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "app.homepage.header.poweredBy_jsx",
            elements: {
              Container: CUIHStack,
              HubSpotLinkedLogo
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(CheckUsernameAvailable, {})]
  });
};
export default HomepageHeaderContent;